<template>
  <div class="card">
    <div class="card-body">
      <el-collapse v-model="activeCollapse" accordion>
        <el-collapse-item name="work-info">
          <template #title>
            <titles text="İş məlumatı" />
          </template>

          <hr style="margin-top:0;margin-bottom: 15px;" />
          <div class="row">
            <div class="col-md-6">
              <div style="color: #495057 !important; font-size: 14px;">
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta müqaviləsi</div>
                  <div class="col-8">{{ data.insuranceContract }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta şəhadətnaməsi №</div>
                  <div class="col-8">{{ data.policyNumber }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta növü</div>
                  <div class="col-8">{{ data.insuranceTypeName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Filial</div>
                  <div class="col-8">{{ data.branchName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığortalı</div>
                  <div class="col-8">{{ data.insuredName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta predmeti</div>
                  <div class="col-8">{{ data.insuredItemModel + " " + data.insuredItemRegNum + " " +
                    data.insuredItemYear }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Oturacaq sayı</div>
                  <div class="col-8">{{ data.numberOfSeats }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığortanın başlama və bitmə tarixi</div>
                  <div class="col-8">{{ formatDate(data.startDateStr) }} - {{ formatDate(data.endDateStr) }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta məbləği</div>
                  <div class="col-8">{{ data.insuranceSum }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərəri müəyyən edən müəssisə</div>
                  <div class="col-8">{{ data.basisPrice }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərərin müəyyən edildiyi tarix</div>
                  <div class="col-8">{{ formatDate(data.damageDateStr) }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Ümumi zərər məbləği</div>
                  <div class="col-8">{{ data.damageSumLetter }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərərçəkənin zərərdə payı</div>
                  <div class="col-8">{{ data.damagePercentage }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Hesablanmış sığorta ödənişi</div>
                  <div class="col-8">{{ data.paymentSumLetter }}</div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div style="color: #495057 !important; font-size: 14px;">
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Hadisənin baş verdiyi tarix</div>
                  <div class="col-8">{{ formatDate(data.accidentDateStr) }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Məlumat vermə tarixi</div>
                  <div class="col-8">{{ formatDate(data.callDateStr) }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta hadisəsinin baş verdiyi ərazi</div>
                  <div class="col-8">{{ data.place }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Hadisədə zərərvuran şəxs</div>
                  <div class="col-8">{{ data.injuredName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Hadisədə zərər çəkənlərin sayı</div>
                  <div class="col-8">{{ data.vehicleCount }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərərçəkən avtomobilin sürücüsü</div>
                  <div class="col-8">{{ data.victimName }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərərçəkən avtomobilin sürücüsünün əlaqə nömrəsi</div>
                  <div class="col-8">{{ data.victimPhone }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Zərər vurulmuş predmetə dair məlumat</div>
                  <div class="col-8">{{ data.damagedInsItemModel + " " +
                    data.damagedInsItemRegNum + " " +
                    data.damagedInsItemYear }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta hadisəsinin növü</div>
                  <div class="col-8">
                    {{ data.damageCategoryName }}
                    <span v-if="data.damageCategoryName === 'Xəsarət'">
                      - {{ data.medDamageTypeName }}
                    </span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Sığorta ödənişini alan</div>
                  <div class="col-8">{{ data.paymentReceivedPerson }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 font-weight-bold">Telefon nömrəsi</div>
                  <div class="col-8">{{ data.paymentReceivedPersonPhone }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import Titles from "@/project/Components/Titles.vue";

export default {
  components: {
    Titles,
  },
  props: {
    id: [String, Number],
    data: {
      type: Object,
      required: true
    },
    lastStatus: { type: Number }
  },
  data() {
    return {
      subrogationLoading: false,
      loading: false,
      activeCollapse: this.lastStatus > 10 ? [] : ['work-info']
    };
  },
  watch: {
    lastStatus(val) {
      this.activeCollapse = val > 10 ? [] : ['work-info'];
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },
  },
};
</script>

<style scoped>
.col-8{
  color:#222222;
}
</style>
